import React from "react";

// others
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  AddDocs,
  LeaseTerms,
  AddPayment,
  PaymentPlan,
  GenerateDoc,
  TenantDetails,
  ChangeHistory,
  RenewalTermsModal,
  EditPaymentSchedule,
  EditTerminationProcess,
  MoveOutBreakdown,
} from "./modalContent";
import AttachDocs from "./modalContent/AttachDocs";
import RequestBookingExtension from "./modalContent/RequestBookingExtension";
import AddTorRules from "./Commercial/AddTorRules";
import AddTorReport from "./AddTorReport";
import LeaseConfiguration from "../../../organism/LeaseConfiguration";
import AdditionalTerms from "../../../organism/LeaseConfiguration/components/AdditionalTerms";
import { CustomFieldsForm } from "./CustomFields";
import { AppDispatch } from "../../../../redux/store";
import { getBookingDetail } from "../ducks/actions";
import { FinancialDimensionsForm } from "../../../organism";

import { ViewBillingSchedule } from "./schedule/ViewBillingSchedule";

import { BaseRentPaymentScheduleRow, TorScheduleRow } from "./Commercial/add-plan/api";
import { PreviewTorSchedule } from "./modalContent/PreviewTorSchedule";

interface ModalProps {
  modalPayload: any;
  renewal?: boolean;
  className?: string;
  updateState?: (obj: object) => void;
  setRenewalFormConfirm?: (obj: Boolean) => void;
  renewalFormConform?: Boolean;
  requestExtension?: any;
  bookingExpiryDate?: any;
  unitPaymentPlan?: Object;
  showPaymentPlan?: Boolean;
  historyData?: Object;
  isCustomePaymentSchedule?: boolean;
  setShowPaymentPlan?: (obj) => void;
  setPaymentScheduler?: (obj) => object;
  customePlanLoading?: boolean;
  leaseConfigModal?: boolean;
  setLeaseConfigModal?: (obj) => void;
  breakdownData?: BaseRentPaymentScheduleRow[];
  torScheduleData?: TorScheduleRow[];
  loading?: boolean;
  modalTitle?: React.ReactNode;
}
const index = (props: ModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const closeModal = () => {
    props?.updateState?.({
      modalPayload: { ...props?.modalPayload, open: false },
    });
  };

  const onModalClose = () => {
    if (props.showPaymentPlan) {
      props?.setShowPaymentPlan && props?.setShowPaymentPlan(false);
    } else if (props.setLeaseConfigModal) {
      props.setLeaseConfigModal(false);
    } else {
      closeModal();
      props?.setRenewalFormConfirm && props?.setRenewalFormConfirm(false);
      props?.requestExtension && props?.requestExtension(false);
    }
  };

  const leaseConfigClose = (type: Boolean) => {
    props.updateState &&
      props.updateState({
        modalPayload: { iKey: "40", title: "", width: "1000px", extraText: "", open: false },
      });
  };
  const openModal = () => {
    if (props.showPaymentPlan || props.modalPayload.open || props?.leaseConfigModal) return true;
    else return false;
  };
  return (
    <Modal
      centered
      width={props?.modalPayload?.width || "97%"}
      footer={null}
      className={props.className + " " + props?.modalPayload?.className}
      open={openModal()}
      title={props.modalTitle ?? props.modalPayload.title}
      destroyOnClose={true}
      onCancel={() => onModalClose()}
      maskClosable={false}
    >
      {props.modalPayload?.extraText && <p className="info-label">{props.modalPayload?.extraText}</p>}

      {props.modalPayload?.iKey === "1" && (
        <TenantDetails parentState={props.updateState} kycDetails={props?.modalPayload?.kycDetails} />
      )}

      {props.modalPayload?.iKey === "2" && <LeaseTerms renewal={props.renewal} parentState={props.updateState} />}

      {props.modalPayload?.iKey === "3" && (
        <EditPaymentSchedule
          renewal={props.renewal}
          parentState={props.updateState}
          isCustomePaymentPlan={props?.isCustomePaymentSchedule}
          setPaymentScheduler={props.setPaymentScheduler}
          customePlanLoading={props?.customePlanLoading}
        />
      )}

      {props.modalPayload?.iKey === "4" && (
        <RenewalTermsModal
          onModalClose={onModalClose}
          parentState={props.updateState}
          renewalFormConform={props?.renewalFormConform}
        />
      )}

      {props.modalPayload?.iKey === "5" && <AddPayment parentState={props.updateState} renewal={props.renewal} />}

      {props.modalPayload?.iKey === "6" && <AddDocs parentState={props.updateState} />}

      {props.modalPayload?.iKey === "7" && <GenerateDoc parentState={props.updateState} />}

      {props.modalPayload?.iKey === "8" && (
        <PaymentPlan unitPaymentPlan={props?.unitPaymentPlan} parentState={props.updateState} />
      )}

      {props.modalPayload?.iKey === "11" && (
        <ChangeHistory
          historyData={props?.historyData}
          onModalClose={onModalClose}
          screen={props.modalPayload?.screen}
          parentState={props.updateState}
        />
      )}

      {props.modalPayload?.iKey === "15" && (
        <AttachDocs parentState={props.updateState} data={props?.modalPayload?.attachDoc} />
      )}

      {props.modalPayload?.iKey === "16" && (
        <RequestBookingExtension
          requestExtension={props?.requestExtension}
          bookingExpiryDate={props?.bookingExpiryDate}
        />
      )}

      {props.modalPayload?.iKey === "17" && (
        <EditTerminationProcess renewal={props.renewal} parentState={props.updateState} />
      )}

      {props.modalPayload?.iKey === "32" && (
        <AddTorRules
          // renewal={props.renewal}
          parentState={props.updateState}
        />
      )}

      {props.modalPayload?.iKey === "30" && <AddTorReport parentState={props.updateState} />}
      {props.modalPayload?.iKey === "40" && <LeaseConfiguration onToggle={leaseConfigClose} />}
      {props.modalPayload?.iKey === "move-out-breakdown" && <MoveOutBreakdown />}
      {props.modalPayload?.iKey === "custom-fields" && <CustomFieldsForm onClose={closeModal} />}
      {props.modalPayload?.iKey === "financial-dimensions" && (
        <FinancialDimensionsForm
          isOpen={props?.modalPayload?.open}
          onClose={closeModal}
          onSubmitSuccess={() => dispatch(getBookingDetail(bookingDetails?.leaseId))}
          propertyId={bookingDetails?.propertyId}
          propertyFinancialDimensions={bookingDetails?.propertyDetails?.financialDimensions}
        />
      )}
      {props.modalPayload?.iKey === "50" && (
        <AdditionalTerms
          isReadOnly={props.modalPayload?.isSignedByBoth}
          onToggle={(open) => props.updateState?.({ modalPayload: { open } })}
        />
      )}

      {props.modalPayload?.iKey === "51" && <ViewBillingSchedule rows={props.breakdownData} />}

      {props.modalPayload?.iKey === "52" && (
        <PreviewTorSchedule torScheduleData={props?.torScheduleData} loading={props?.loading} />
      )}
    </Modal>
  );
};

export default React.memo(index);
